import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import React, {useState, useEffect} from "react";


import '../estilos/partials.css';
function SidebarCamarografo(){

    const paramsUsuario = useParams(); // obtenemos params para poner en url
    const navigate = useNavigate();

    const [usuario, setUsuario]               = useState(null);
    const [cargando, setCargando]             = useState(true);
    const [infoUsuarioLocal, setInfoLocal] = useState(null); // Variables localstorage

    useEffect(() => {
    (async () => {
      try {
        setCargando(true);

        const verifToken = axios.get("/verificar-token", { withCredentials: true });
        

        const [ resVerif ] = await Promise.all([verifToken ]);
        if(!resVerif.data.usuario){ return navigate("/alerta", {state: {titulo:"No estás autenticado", mensaje:"No estás autenticado, por favor inicia sesión.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        if(resVerif.data.usuario.tipo === "Administrador" || resVerif.data.usuario.tipo === "Cliente" ){ cerrarSesion(); return navigate("/alerta", {state: {titulo:"No eres Camarógrafo", mensaje:"No eres camarógrafo.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        setUsuario(resVerif.data.usuario);
      } 
      catch (err) { console.error("Error en una de las solicitudes:", err); } 
      finally { setCargando(false);}
    })();
    }, []);

    
    async function cerrarSesion(event) {
        localStorage.clear(); // Limpiamos el almacenamiento local.
        const resCerrar = await axios.post("/logout");
    }

    function handleLogOut(event){
        // evita el parpadeo predefinido
        event.preventDefault();

        localStorage.clear(); // limpiamos el almacentaiento local.
        axios.post("/logout")
        .then(function(response){
            console.log(response);
            navigate("/");
        });
    }


    return(
        <div id='miSidebar' className="d-flex flex-column flex-shrink-0" style={{width: "4.5rem"}}>
        {(usuario)
        ?<ul className="nav nav-pills nav-flush flex-column mb-auto text-center">
            {/* Mostrar home a todos, menos a narrador  */}
            {(usuario.tipo!=="Narrador") 
            ? <li className="nav-item">
                <a href={"/camarografo/home/" + paramsUsuario.username} className="nav-link py-3 border-bottom border-dark-subtle rounded-0" aria-current="page" title="Home" data-bs-toggle="tooltip" data-bs-placement="right">
                    <i className="bi bi-house" style={{fontSize: "25px", color: "white"}}></i>
                </a>
            </li>
            :null }
            
            {/* Mostrar Grabar a camarografo y camarografoEditor  */}
            {(usuario.tipo!=="Narrador") 
            ?  <li>
                <a href={"/camarografo/grabar/" +paramsUsuario.username + "/1" } className="nav-link py-3 border-bottom border-dark-subtle rounded-0" title="Grabar" data-bs-toggle="tooltip" data-bs-placement="right">
                    <i className="bi bi-camera-video" style={{fontSize: "25px", color: "white"}}></i>
                </a>
            </li>
            :null}
           
            {/* Mostrar completar procesos a camarografoEditor solamente  */}
            {/* {(usuario.tipo==="CamarografoEditor") 
            ? <li>
                <a href={"/camarografo/completar-procesos/" + paramsUsuario.username } className="nav-link py-3 border-bottom border-dark-subtle rounded-0" title="Completar procesos" data-bs-toggle="tooltip" data-bs-placement="right">
                    <i className="bi bi-arrow-clockwise" style={{fontSize: "25px", color: "white"}}></i>
                </a>
            </li> 
            : null} */}
            
            {/* Mostrar grabar voz a narrador y a camarografoEditor  */}
            {(usuario.tipo!=="Camarografo") 
            ?  <li>
                <a href={"/camarografo/grabar-voz-por-solicitud/" + paramsUsuario.username } className="nav-link py-3 border-bottom border-dark-subtle rounded-0" title="Grabar voz" data-bs-toggle="tooltip" data-bs-placement="right">
                    <i className="bi bi-record-circle" style={{fontSize: "25px", color: "white"}}></i>
                </a>
            </li> 
                :null}
           
        </ul>
        : null}


 
            <div className="dropdown border-top">
            <a href="/" className="d-flex align-items-center justify-content-center p-3 link-body-emphasis text-decoration-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <img src="/imagenes/marca/favicon.ico" alt="mdo" width="24" height="24" className="rounded-circle" />
            </a>
            <ul className="dropdown-menu text-small shadow">
                {/* <li><a className="dropdown-item" href={"/admin/mi-cuenta/" + paramsUsuario.username }>Mi cuenta</a></li> */}
                <li><hr className="dropdown-divider"/></li>
                <li>
                    <form>
                        <button onClick={handleLogOut} className="btn btn-light" type="submit">Cerrar Sesión</button>
                    </form>
                </li>
            </ul>
            </div>
        </div>
    )
}

export default SidebarCamarografo;